<template>
	<v-autocomplete
		v-model="internalValue"
		:items="items"
		:item-text="itemText"
		item-value="id"
		:label="label"
		:placeholder="$t('search') + '...'"
		:rules="rules"
		:loading="loading"
		:disabled="disabled"
		prepend-inner-icon="mdi-domain"
		outlined
		dense
		clearable
		auto-select-first
		:no-data-text="$t('no-results') || 'No organizations found'"
		:filter="customFilter"
	>
		<template #item="{ item }">
			<v-list-item-content>
				<v-list-item-title>{{ itemText(item) }}</v-list-item-title>
				<v-list-item-subtitle class="text-caption">
					{{ item.id }}
				</v-list-item-subtitle>
			</v-list-item-content>
		</template>
	</v-autocomplete>
</template>

<script>
export default {
	name: "OrganizationSearchSelect",

	props: {
		value: {
			type: String,
			default: ""
		},

		organizations: {
			type: Array,
			default: () => []
		},

		label: {
			type: String,
			default: ""
		},

		rules: {
			type: Array,
			default: () => []
		},

		loading: {
			type: Boolean,
			default: false
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		internalValue: {
			get() {
				return this.value;
			},

			set(v) {
				this.$emit("input", v || "");
			}
		},

		items() {
			return this.organizations;
		}
	},

	methods: {
		itemText(org) {
			if (!org) return "";

			const name = org.name;
			let displayName = "";

			if (typeof name === "object" && name) {
				const locale = this.$i18n?.locale || "fr-FR";

				displayName =
					name[locale] || name["fr-FR"] || Object.values(name)[0] || "";
			} else if (typeof name === "string") {
				displayName = name;
			}

			return displayName ? `${displayName} (${org.id})` : org.id;
		},

		normalizeText(text) {
			return String(text || "")
				.toLowerCase()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "");
		},

		customFilter(item, queryText) {
			if (!queryText) return true;

			const q = this.normalizeText(queryText);

			return (
				this.normalizeText(this.itemText(item)).includes(q) ||
				this.normalizeText(item.id).includes(q)
			);
		}
	}
};
</script>
